/** @format */

import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import Pagination from 'react-js-pagination'
import { Url } from '../../config/config'
import { dateFormat, getSerialNumber } from '../../utils'
import Modal from 'react-bootstrap/Modal'
import useFullPageLoader from '../../hooks/useFullPageLoader'
import { isLoggedIn } from '../../utils'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import useDebounce from '../../hooks/useDebounce'
import useButtonLoader from '../../hooks/useButtonLoader'

export default function User() {
  const [record, setRecord] = useState([])
  const [total, setTotal] = useState(0)
  const [sourceFilter, setSourceFilter] = useState([])
  const [sourceValue, setSourceValue] = useState('')
  //const [activePage, setActivePage] = useState(1);
  const [BlockModal, setBlockModal] = useState(false)
  const [id, setId] = useState('')
  const [status, setStatus] = useState(true)
  const [loader, showLoader, hideLoader] = useFullPageLoader()
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const accessToken = isLoggedIn().token

  let currentActivePage = parseInt(localStorage.getItem('userActivePage'))

  const [limit, setLimit] = useState('10')
  const [activePage, setActivePage] = useState(currentActivePage || 1)
  const [searchValue, setSearchValue] = useState('')
  const debounceValue = useDebounce(searchValue, 500)

  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    'Download',
    'Please wait...',
  )

  //**************************User Listing************* */
  const userList = async (page = activePage, query = '') => {
    try {
      showLoader()
      // console.log("query", query)
      const res = await axios({
        url: `${Url}/userlist?page=${page}&search=${query}&utmSource=${sourceValue}&limit=${limit}&startDate=${
          startDate !== '' ? new Date(startDate).toISOString() : ''
        }&endDate=${endDate !== '' ? new Date(endDate).toISOString() : ''}`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      hideLoader()

      if (res.data.status === 200) {
        setRecord(res.data.data.user)
        setTotal(res.data.data.total)
      } else {
        toast.error('Something went to wrong')
      }
    } catch (err) {
      console.log(err)
    }
  }

  //************************ Handle Filter by source ************************//
  const getSourceFilter = async () => {
    try {
      const res = await axios({
        url: `${Url}/utm_list`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      console.log('i am res', res)
      if (res.data.status === 200) {
        setSourceFilter(res.data.data.utm)
      } else {
        toast.error('Something went to wrong')
      }
    } catch (err) {
      console.log(err)
    }
  }

  //************* Download excel file******** */

  const downloadExcleFile = async () => {
    // console.log("hello")
    try {
      setSubmitLoading(true)
      const response = await axios.get(`${Url}/export_user`, {
        params: {
          search: debounceValue,
          utmSource: sourceValue,
          startDate: startDate ? new Date(startDate).toISOString() : '',
          endDate: endDate ? new Date(endDate).toISOString() : '',
        },
        responseType: 'blob',
      })

      console.log('response', response)

      if (response.status === 200) {
        setSubmitLoading(false)
        const currentDate = new Date()
        const formattedDate = currentDate.toISOString().slice(0, 10)

        let rnFile = `${formattedDate}.xlsx`

        // Extract the filename from the response headers
        const contentDisposition = response.headers['content-disposition']
        console.log('contentDisposition', contentDisposition)
        // return false
        const matches = /filename="([^"]+)"/.exec(contentDisposition)
        const filename = matches ? matches[1] : 'excel-file.xlsx'

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url

        // link.setAttribute('download', `user_${new Date().getTime()}.xlsx`);
        link.setAttribute('download', `user_${rnFile}`)
        document.body.appendChild(link)
        link.click()

        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)
      } else {
        setSubmitLoading(false)

        toast.error('Something went to wrong')
      }
    } catch (error) {
      setSubmitLoading(false)

      console.error('Error downloading file:', error)
    }
  }

  //*************Handel Search******** */
  const handelSearch = (e) => {
    setSearchValue(e.target.value)
    //console.log(e.target.value);
  }

  //*********************Handel User Block UnBlock****************************************** */
  const handleBlockClose = () => {
    setBlockModal(false)
  }

  const handleBlockShow = (id) => {
    setBlockModal(true)
  }

  const handleChecked = (e, id) => {
    handleBlockShow()
    setStatus(e.target.checked)
    setId(id)
  }
  const updateStatus = async () => {
    try {
      let res = await axios({
        url: `${Url}/userStatusChange`,
        method: 'POST',
        headers: {
          // Authorization: "Bearer " + accessToken,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data: {
          userId: id,
          isActive: status,
        },
      })
      if (res.data.status === 200) {
        handleBlockClose()
        toast.success(res.data.message)
        userList(activePage)
      } else {
        toast.error('Something went to wrong')
      }
    } catch (err) {
      console.log(err)
    }
  }

  //*****************Handel Delete Action****************** */
  const [DeleteModal, setDeleteModal] = useState(false)
  const handelDeleteShow = (id) => {
    //console.log(id);
    setDeleteModal(true)
    setId(id)
  }
  const handelDeleteClose = () => {
    setDeleteModal(false)
  }

  const handelDelete = async () => {
    try {
      const res = await axios({
        url: `${Url}/deleteUser`,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + accessToken,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data: {
          userId: id,
        },
      })
      if (res.data.status === 200) {
        handelDeleteClose()
        toast.success(res.data.message)
        userList(activePage)
      } else {
        toast.error('Something went to wrong')
      }
    } catch (err) {
      console.log(err)
    }
  }

  // useEffect(() => {
  //   if (startDate && endDate) {
  //     userList()
  //   }
  // }, []);

  //*************Handel Pagination********** */
  const handlePageChange = (event) => {
    console.log(event)
    setActivePage(event)
    userList(event)
  }

  const handleLimitChange = (e) => {
  
    setLimit(
   e.target.value
    );
    setLimit(e.target.value)
    setActivePage(1)
  }

  React.useEffect(() => {
    // let page= 5
    if (total && sourceValue) {
      if (total <= 10) {
        setActivePage(1)
      }
      if (total > 10) {
        let assumingNum = total / 10
        if (assumingNum + 1 <= activePage) {
          setActivePage(1)
        }
      }
    }
    if (startDate && endDate && total) {
      if (total <= 10) {
        setActivePage(1)
      }
      if (total > 10) {
        let assumingNum = total / 10
        if (assumingNum + 1 <= activePage) {
          setActivePage(1)
        }
      }
    }

    if (debounceValue && total) {
      if (total <= 10) {
        setActivePage(1)
      }
      if (total > 10) {
        let assumingNum = total / 10
        if (assumingNum + 1 <= activePage) {
          setActivePage(1)
        }
      }
    }
  }, [total, sourceValue, startDate, endDate, debounceValue])

  useEffect(() => {
    getSourceFilter()
  }, [])

  useEffect(() => {
    userList(activePage)
    getSourceFilter()
  }, [sourceValue])

  useEffect(() => {
    localStorage.setItem('userActivePage', activePage)
    userList(activePage, debounceValue)
  }, [activePage, debounceValue, startDate, endDate, limit])

  var count = (activePage - 1) * 10 + 1

  console.log('active', activePage)
  console.log('total', total)

  return (
    <React.Fragment>
      <title>Volt | User</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="content_box_header cstm_content_box-header">
              <h4 className="Title">User Management</h4>
              {/* <div className="SearchBox"></div> */}
              <div className="SearchBox">
                <div className="customInput">
                  <input
                    type="text"
                    placeholder="Search"
                    onChange={handelSearch}
                  />
                </div>
                {/* <button>Apply</button> */}
                <div className="customInput date_input">
                  <DatePicker
                    placeholderText="Start Date"
                    // className="input dataPickerWidth"
                    selected={startDate}
                    value={startDate}
                    showYearDropdown
                    yearDropdownItemNumber={100}
                    scrollableYearDropdown
                    showMonthDropdown
                    useShortMonthInDropdown
                    onChange={(date) =>
                      date ? setStartDate(date) : setStartDate('')
                    }
                    dateFormat="yyyy-MM-dd"
                    // maxDate={new Date(endDate)}
                  />
                </div>

                <div className="customInput date_input">
                  <div className="form-field date-picker ">
                    <DatePicker
                      placeholderText="End Date"
                      // className="input dataPickerWidth"
                      selected={endDate}
                      value={endDate}
                      showYearDropdown
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown
                      showMonthDropdown
                      useShortMonthInDropdown
                      onChange={(date) =>
                        date ? setEndDate(date) : setEndDate('')
                      }
                      dateFormat="yyyy-MM-dd"
                      minDate={new Date(startDate)}
                    />
                  </div>
                </div>
                <select
                  className="mx-2 cstm_select_select_drop"
                  value={limit}
                  // onChange={(e) => setLimit(e.target.value)}
                  onChange={handleLimitChange}
                  style={{ padding: '0.25rem', height: '2.5rem' }}
                >
                  <option value="10">10 </option>
                  <option value="50">50 </option>
                  <option value="100">100 </option>
                  <option value="500">500 </option>
                  <option value="all">All </option>
                </select>
                <select
                  className="mx-2 customInput"
                  value={sourceValue}
                  onChange={(e) => setSourceValue(e.target.value)}
                  style={{ padding: '0.25rem', height: '2.5rem' }}
                >
                  <option value="">Filter by Source&nbsp;</option>
                  {sourceFilter &&
                    sourceFilter.map((el, i) => {
                      return (
                        <option key={i} value={el.utm_source}>
                          {el.utm_source}
                        </option>
                      )
                    })}
                </select>

                {/* <a
                className="customBtn"
                href={`${Url}/export_user?search=${debounceValue}&utmSource=${sourceValue}&startDate=${startDate !== "" ? new Date(startDate).toISOString() : ""}&endDate=${endDate !== "" ? new Date(endDate).toISOString() : ""}`}
                target="__blank"
                >
                  <i className="fa fa-file-excel-o" aria-hidden="true"></i>{" "}
                  Download
                </a> */}
                <button
                  className="button"
                  onClick={downloadExcleFile}
                  ref={submitButtonElement}
                >
                  download
                </button>
              </div>
            </div>
            <div className="TableList">
              {loader}
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Username</th>
                    <th>Company Name</th>
                    <th>Phone Number </th>
                    <th>Email Id </th>
                    {/* <th>State</th> */}
                    <th>Created Date</th>
                    <th>Status</th>
                    {/* <th>Eligibility Status</th> */}
                    <th>Pre Approved Solar System</th>
                    <th>Utm Source</th>
                    <th>Details</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {record &&
                    record.length > 0 &&
                    record.map((user, i) => (
                      <tr key={i}>
                        <td>{count++}</td>
                        <td>
                          {user.firstName && user.lastName
                            ? user.firstName + ' ' + user.lastName
                            : '- - -'}
                        </td>
                        <td>{user.nameOfBusiness}</td>
                        <td>{user.contactNum}</td>
                        <td>{user.email}</td>

                        {/* <td>{user.state}</td> */}
                        <td>{dateFormat(user.createdAt)}</td>
                        <td>
                          {user.isActive === true ? 'Active' : 'Inactive'}
                        </td>
                        {/* <td>
                          {user.isEligible === true ? (
                            'Eligible'
                          ) : (
                            <>
                              {user.isEligible === false
                                ? 'Not Eligible'
                                : '- - -'}
                            </>
                          )}
                        </td> */}
                        <td>
                          {user.approvedSolarSystemOutput !== null
                            ? user.approvedSolarSystemOutput
                              ? user.approvedSolarSystemOutput.toFixed(2) +
                                ' Kw'
                              : 'Not Eligible'
                            : 'Not Eligible'}
                        </td>
                        <td> {user.utm_source} </td>

                        <td>
                          <Link to={`/user/details/${user._id}`}>
                            <i className="fa fa-eye"></i>
                          </Link>
                        </td>
                        <td>
                          <div className="action_button_wrap">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="status"
                                checked={user.isActive}
                                onChange={(e) => handleChecked(e, user._id)}
                              />
                              <label className="form-check-label"></label>
                            </div>
                            <Link to={`update/${user._id}`}>
                              <span className=" px-1">
                                <i className="fa fa-pencil text-primary"></i>
                              </span>
                            </Link>
                            <span
                              className="Red"
                              onClick={(e) => handelDeleteShow(user._id)}
                            >
                              <i className="fa fa-trash"></i>
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={'previous'}
                  nextLabel={'next'}
                  itemsCountPerPage={limit}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="ModalBox">
        {/* block or unblock model */}
        <Modal show={BlockModal} onHide={handleBlockClose}>
          <Modal.Header closeButton onClick={handleBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to change the status?</Modal.Body>
          <Modal.Footer>
            <button
              className="secondary"
              variant="secondary"
              onClick={handleBlockClose}
            >
              No
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={updateStatus}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>

        {/* Start Delete Modal */}
        <Modal show={DeleteModal} onHide={handelDeleteClose}>
          <Modal.Header closeButton onClick={handelDeleteClose}>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to delete this user?</Modal.Body>
          <Modal.Footer>
            <button
              className="secondary"
              variant="secondary"
              onClick={handelDeleteClose}
            >
              No
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={handelDelete}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* End delete Modal */}
      </div>
    </React.Fragment>
  )
}
